import { useNavigate } from "react-router-dom";
import BottomNav from "../components/BottomNav";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";

const T = { night:"#0A1F3D", royal:"#1263B0", cyan:"#1CBCD3",
  white:"#fff", bg:"#F7F9FC", border:"#E2E8F0" };

export default function Profile() {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const handleLogout = () => { logout(); nav("/"); };

  return (
    <div style={{ minHeight:"100vh", background:T.bg, fontFamily:"'DM Sans',sans-serif" }}>
      <div style={{ background:`linear-gradient(135deg,${T.night},${T.royal})`,
        padding:"20px 24px", display:"flex", alignItems:"center", gap:"16px" }}>
        <button onClick={()=>nav("/dashboard")}
          style={{ background:"transparent", border:"none",
            color:T.white, fontSize:"20px", cursor:"pointer" }}>←</button>
        <h1 style={{ color:T.white, fontSize:"18px", fontWeight:700, margin:0 }}>
          {t("profile.title")}
        </h1>
      </div>

      <div style={{ maxWidth:"500px", margin:"32px auto", padding:"0 24px" }}>
        <div style={{ background:T.white, borderRadius:"20px",
          padding:"32px", border:"1px solid #E2E8F0", textAlign:"center", marginBottom:"20px" }}>
          <div style={{ width:"80px", height:"80px", borderRadius:"50%",
            background:`linear-gradient(135deg,${T.royal},${T.cyan})`,
            display:"flex", alignItems:"center", justifyContent:"center",
            fontSize:"32px", margin:"0 auto 16px" }}>👤</div>
          <h2 style={{ fontSize:"20px", fontWeight:700, color:T.night, margin:"0 0 4px" }}>
            {user?.firstName || user?.first_name} {user?.lastName || user?.last_name}
          </h2>
          <p style={{ color:"#64748B", fontSize:"14px", margin:0 }}>
            {user?.phoneNumber || user?.phone_number}
          </p>
        </div>

        <button onClick={handleLogout}
          style={{ width:"100%", padding:"14px", background:"#FEF2F2",
            color:"#B91C1C", border:"1.5px solid #FECACA",
            borderRadius:"12px", fontWeight:700, cursor:"pointer", fontSize:"15px" }}>
          {t("dashboard.logout")}
        </button>
      </div>
      <BottomNav />
    </div>
  );
}
